import React from 'react';

import { DashboardRoutePath } from '../../../modules/dashboard';
import { BurgerProps } from '../Burger/Burger';
import {
  SearchIcon,
  NotificationIconNav,
  SettingsIconNav,
  ProfileImageIcon,
} from '../../../assets/NavBar';
import { strings } from '../../../strings';
import { ProfileImage } from '../../Typhography/NavBarStyles';
import { PlaceHolderIcon } from '../../Typhography/InputStyled';
import {
  Res,
  ResIcon,
  ResponsiveIcons,
  List,
  ResponsiveSearch,
  ResponsiveSearchInput,
  ResponsiveLink,
} from '../../Typhography/ResponsiveNavStyles';

export default function ResponsiveNav(props: BurgerProps) {
  return (
    <Res open={props.open}>
      <ResponsiveIcons>
        <ProfileImage src={ProfileImageIcon} />
        <ResIcon src={NotificationIconNav} />
        <ResIcon src={SettingsIconNav} />
      </ResponsiveIcons>
      <List>
        <li>
          <ResponsiveSearch width="50px">
            <ResponsiveSearchInput placeholder={strings.navSearchPlaceholder} name="Search" />
            <PlaceHolderIcon top={16} src={SearchIcon} />
          </ResponsiveSearch>
        </li>
        <li>
          <ResponsiveLink activeClassName="any" to={DashboardRoutePath.APPROVE_PUZZLES}>
            {strings.navApprovePuzzlesTab}
          </ResponsiveLink>
        </li>
        <li>
          <ResponsiveLink activeClassName="any" to={DashboardRoutePath.ARTISTS}>
            {strings.navArtistsTab}
          </ResponsiveLink>
        </li>
        {/* <li>
          <ResponsiveLink activeClassName="any" to={DashboardRoutePath.EVENTS}>
            {strings.navEventsTab}
          </ResponsiveLink>
        </li>
        <li>
          <ResponsiveLink activeClassName="any" to={DashboardRoutePath.ANALYTICS}>
            {strings.navAnalyticsTab}
          </ResponsiveLink>
        </li> */}
        <li>
          <ResponsiveLink activeClassName="any" to={DashboardRoutePath.PUZZLES}>
            {strings.navCreateTab}
          </ResponsiveLink>
        </li>
      </List>
    </Res>
  );
}
